export type ClassDashboardRouteState = {
  activeTabIndex?: number;
  programmeStartDate?: Date | undefined;
  fromChildAttendanceReport?: boolean;
  classroomGroupIdFromClassTab?: string;
  messageReference?: string;
};

export const enum TabsItemsWithAttendance {
  ATTENDANCE = 0,
  CHILDREN = 1,
  PROGRAMME = 2,
  RESOURCES = 3,
}

export const enum TabsItems {
  CHILDREN = 0,
  PROGRAMME = 1,
  RESOURCES = 2,
}

export const enum TabsItemForPrincipal {
  ATTENDANCE = 0,
  PRACTITIONERS = 1,
  CHILDREN = 2,
  PROGRAMME = 3,
  RESOURCES = 4,
}

export const NavigationNames = {
  Home: 'Home',
  Profile: {
    Profile: 'Profile',
    Account: 'About me',
    Preschool: 'Preschool',
    Journey: 'Journey',
  },
  Classroom: {
    Classroom: 'Classroom',
    Classes: 'Classes',
    Attendance: 'Attendance',
    Progress: 'Progress',
    Activities: 'Activities',
    Resources: 'Resources',
    Practitioners: 'Practitioners',
    Programme: 'Programme',
  },
  Business: {
    Business: 'Business',
    Staff: 'Staff',
    Money: 'Money',
    Resources: 'Resources',
  },
  Community: {
    Community: 'Community',
    Resources: 'Resources',
  },
  Training: 'Training',
  Points: 'Points',
  Messages: 'Messages',
  Practitioners: 'Practitioners',
  Calendar: 'Calendar',
  Logout: 'Log out',
};
